import { SVGAttributes } from 'react'

const svg = (
	<svg className="h-4 w-4 lg:h-5 lg:w-5" fill="none" viewBox="0 0 24 24">
		<path fill="currentColor" d="m12.675 1.504 2.845 5.953c.092.192.367.384.551.48l6.242.96a.795.795 0 0 1 .46 1.344l-4.499 4.609c-.184.192-.275.48-.184.672l1.102 6.529c.092.672-.55 1.152-1.102.864l-5.599-3.073c-.184-.096-.459-.096-.734 0l-5.6 3.073c-.55.288-1.193-.192-1.101-.864l1.101-6.53c0-.287 0-.575-.183-.671L1.476 10.24c-.735-.48-.551-1.248.091-1.344l6.242-.96c.276 0 .46-.192.551-.48l2.846-5.953c.367-.672 1.101-.672 1.469 0Z" />
		<path className="text-yellow-400" fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M11.65 1.733 8.825 7.645c-.132.38-.44.77-.972.791l-6.21.955h-.002a.204.204 0 0 0-.115.048.082.082 0 0 0-.025.05c-.004.027-.002.17.248.334l.046.03 4.495 4.605c.228.16.306.406.335.562.032.168.032.353.032.483v.061l-1.107 6.56a.34.34 0 0 0 .12.323c.077.059.166.07.252.026l5.63-3.09.04-.013c.351-.122.782-.153 1.13.03l.01.004 5.594 3.07a.226.226 0 0 0 .251-.027.34.34 0 0 0 .12-.322l-1.09-6.466a1 1 0 0 1-.009-.611c.058-.2.169-.391.315-.544l.003-.003 4.495-4.605.001-.002a.295.295 0 0 0-.173-.503h-.002l-6.324-.973-.074-.038a2.43 2.43 0 0 1-.393-.26 1.368 1.368 0 0 1-.377-.448L12.23 1.733c-.114-.203-.237-.233-.29-.233-.053 0-.175.03-.29.233Zm1.485-.426-.022-.043C12.863.804 12.437.5 11.94.5c-.496 0-.922.305-1.173.764l-.006.012-2.867 5.996-.01.033a.313.313 0 0 1-.068.131h-.045l-6.278.966c-.52.079-.918.452-.984.958-.063.485.19.95.644 1.267l4.494 4.604c.003.024.006.056.008.098.002.046.002.095.002.151l-1.096 6.495v.008c-.139 1.01.86 1.88 1.828 1.375l5.568-3.055c.173-.053.28-.028.3-.018l5.593 3.068.009.005c.967.505 1.966-.365 1.828-1.375v-.008l-1.115-6.606-.016-.032a.328.328 0 0 1 .078-.14l.002-.002 4.494-4.605.004-.003a1.295 1.295 0 0 0-.746-2.184h-.001l-6.15-.947a1.414 1.414 0 0 1-.16-.111.747.747 0 0 1-.085-.079l-.022-.027-2.844-5.95.009.018Z" />
	</svg>
)

const Star = ({ className, handleClick }: {
	className: NonNullable<SVGAttributes<SVGSVGElement>['className']>,
	handleClick: (() => void) | null,
}) => (handleClick ? (
	<button type="button" className={`${className} star-rating group-hover:text-yellow-300 focus:ring-0 focus:ring-offset-0`} onClick={handleClick} >
		<style jsx>{`
				.star-rating:hover ~ .star-rating {
					@apply text-transparent;
				}
			`}</style>

		{svg}
	</button>
) : (
	<span className={className}>
		{svg}
	</span>
))

export default function RatingStars({ setRating, rating }: {
	setRating?: (rating: number) => void,
	rating: number,
}): JSX.Element {
	return (
		<div className="flex items-center -ml-1 w-max group">
			{[1, 2, 3, 4, 5].map(index => (
				<Star
					key={index}
					className={`pl-1 ${rating >= index ? 'text-yellow-300' : 'text-transparent'}`}
					handleClick={setRating ? () => setRating(index) : null}
				/>
			))}
		</div>
	)
}
